import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import useIsMobile from "@hooks/useIsMobile";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import { twMerge } from "tailwind-merge";
import { CarSpecsHeader } from "@/components/ui/car-specs-header";
import SplitPaymentDetails from "@/pages/split-payment/components/SplitPaymentDetails";
import { BottomSheet as LegacyBottomSheet } from "@componentsShared/BottomSheet";
import WarrantyBanner from "@/pages/split-payment/components/WarrantyBanner";
import TabbyInfoComponent from "@/pages/checkout/bnpl/tabby/components/TabbyInfoComponent";
import TabbyOTPStep from "@/pages/checkout/bnpl/tabby/components/TabbyOTPStep";
import { handleHasAccountEvent } from "@/utils/common";
import { useLang } from "@/common/Contexts/LanguageContext";
import useHelpers from "@hooks/useHelpers";
import { api__createTabbyCheckoutSession } from "@/pages/checkout/bnpl/tabby/api/tabbyApi";
import { serverUrl } from "@globalConfig";
import { resolveRoadServiceId } from "@/_MiniApps/RoadsideAssistance";
import { useTabbyFinance } from "@/common/Contexts/TabbyFinanceContext";
import { trackEvents } from "@/common/events/events";
import { getPlatformInfo } from "@/utils/GlobalJavascriptFunction";
import { toast } from "sonner";
import { getUtmParams } from "@/common/utmParams";
var TabbyFormContent = function TabbyFormContent(_ref) {
  var _checkoutOrderV2$g4_d, _checkoutOrderV2$sect, _checkoutOrderV2$sect2, _checkoutOrderV2$sect3, _checkoutOrderV2$sect4, _checkoutOrderV2$sect5, _checkoutOrderV2$sect6, _checkoutOrderV2$sect7, _checkoutOrderV2$sect8, _carHeader$specs, _carHeader$car_title;
  var checkoutOrderV2 = _ref.checkoutOrderV2,
    fetch_loading = _ref.fetch_loading,
    userInfo = _ref.userInfo,
    isOtpStep = _ref.isOtpStep,
    autosend = _ref.autosend,
    setIsOtpStep = _ref.setIsOtpStep,
    setIsOtpLoading = _ref.setIsOtpLoading,
    setAutoSend = _ref.setAutoSend,
    onInfoIconClick = _ref.onInfoIconClick,
    _ref$showCancelButton = _ref.showCancelButton,
    showCancelButton = _ref$showCancelButton === void 0 ? false : _ref$showCancelButton,
    onCancelButtonClick = _ref.onCancelButtonClick,
    onFormUpdated = _ref.onFormUpdated,
    onFormCompleted = _ref.onFormCompleted;
  var _useTranslation = useTranslation(["web_checkout_finance", "web_checkout_cash", "web_sell_trade"]),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var isMobile = useIsMobile();
  var _useSession = useSession(),
    isLoggedIn = _useSession.isLoggedIn;
  var lang = useLang();
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useTabbyFinance = useTabbyFinance(),
    tabbyActions = _useTabbyFinance.actions,
    remote_actions = _useTabbyFinance.remote_actions;
  var isDesktop = !isMobile;
  var g4DataLayer = checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$g4_d = checkoutOrderV2.g4_data) === null || _checkoutOrderV2$g4_d === void 0 ? void 0 : _checkoutOrderV2$g4_d.g4_data_layer;
  var selectedWarrantyId = checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$sect = checkoutOrderV2.sections) === null || _checkoutOrderV2$sect === void 0 ? void 0 : (_checkoutOrderV2$sect2 = _checkoutOrderV2$sect.find(function (section) {
    return section.type === "warranty_list";
  })) === null || _checkoutOrderV2$sect2 === void 0 ? void 0 : (_checkoutOrderV2$sect3 = _checkoutOrderV2$sect2.items) === null || _checkoutOrderV2$sect3 === void 0 ? void 0 : (_checkoutOrderV2$sect4 = _checkoutOrderV2$sect3[0]) === null || _checkoutOrderV2$sect4 === void 0 ? void 0 : (_checkoutOrderV2$sect5 = _checkoutOrderV2$sect4.selected) === null || _checkoutOrderV2$sect5 === void 0 ? void 0 : _checkoutOrderV2$sect5.id;
  var handleOtpVerified = function handleOtpVerified(userData) {
    if (!isLoggedIn) {
      handleHasAccountEvent({
        hasAccount: userData.has_account,
        status: "Success",
        phone_number: userData === null || userData === void 0 ? void 0 : userData.phone_number,
        lang: lang,
        referral_location: "tabby_order"
      });
    }
    var post_id = Number((checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : checkoutOrderV2.post_id) || 0);
    var selectedCity = String(userInfo.city_id || "1");
    var tabbyRequest = _objectSpread(_objectSpread(_objectSpread({}, getUtmParams()), {}, {
      post_id: post_id,
      first_name: (userInfo.first_name || "").trim(),
      last_name: (userInfo.family_name || "").trim(),
      phone_number: userInfo.mobile_number || "",
      city_id: parseInt(selectedCity),
      whatsapp_optin: userInfo.whatsapp_optin,
      success_url: "".concat(serverUrl, "/").concat(lang === "en" ? "en/" : "", "finance-apply-tabby/payment-success?post_id=").concat(post_id),
      failure_url: "".concat(serverUrl, "/").concat(lang === "en" ? "en/" : "", "finance-apply-tabby/payment-failed?post_id=").concat(post_id),
      cancel_url: "".concat(serverUrl, "/").concat(lang === "en" ? "en/" : "", "finance-apply-tabby/payment-cancel?post_id=").concat(post_id)
    }, selectedWarrantyId != null && {
      warranty_id: selectedWarrantyId
    }), function () {
      var rsid = resolveRoadServiceId(checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : checkoutOrderV2.sections);
      return rsid != null ? {
        road_service_id: rsid
      } : {};
    }());
    if (setIsOtpLoading) setIsOtpLoading(true);
    api__createTabbyCheckoutSession(tabbyRequest).then(function (response) {
      var _response$data, _checkoutOrderV2$post, _response$data2;
      trackEvents("tabby_form_submit", {
        post_id: post_id,
        order_id: String(((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.order_id) || ""),
        user_city: userInfo.city_name || selectedCity,
        inventory_type: g4DataLayer === null || g4DataLayer === void 0 ? void 0 : g4DataLayer.inventory_type,
        post_make: g4DataLayer === null || g4DataLayer === void 0 ? void 0 : g4DataLayer.post_make,
        post_model: g4DataLayer === null || g4DataLayer === void 0 ? void 0 : g4DataLayer.post_model,
        post_trim: g4DataLayer === null || g4DataLayer === void 0 ? void 0 : g4DataLayer.post_ext,
        post_year: g4DataLayer === null || g4DataLayer === void 0 ? void 0 : g4DataLayer.post_year,
        post_condition: g4DataLayer === null || g4DataLayer === void 0 ? void 0 : g4DataLayer.post_condition,
        post_price: g4DataLayer === null || g4DataLayer === void 0 ? void 0 : g4DataLayer.post_price,
        total_amount: checkoutOrderV2 !== null && checkoutOrderV2 !== void 0 && (_checkoutOrderV2$post = checkoutOrderV2.post) !== null && _checkoutOrderV2$post !== void 0 && _checkoutOrderV2$post.post_price ? parseFloat(checkoutOrderV2.post.post_price.replace(/,/g, "")) : undefined,
        platform: getPlatformInfo(),
        referral_location: "pre-checkout"
      });
      if (response.success && (_response$data2 = response.data) !== null && _response$data2 !== void 0 && _response$data2.checkout_url) {
        var _response$data3;
        tabbyActions === null || tabbyActions === void 0 ? void 0 : tabbyActions.action__updateUserInfo({
          first_name: userInfo.first_name,
          family_name: userInfo.family_name,
          mobile_number: userInfo.mobile_number,
          city_id: selectedCity,
          city_name: userInfo.city_name || null,
          whatsapp_optin: userInfo.whatsapp_optin,
          order_id: String(((_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.order_id) || "")
        });
        onFormCompleted === null || onFormCompleted === void 0 ? void 0 : onFormCompleted();
        window.location.href = response.data.checkout_url;
      } else {
        var _response$data4, _response$data5, _response$data6, _response$data7;
        setIsOtpStep(false);
        if ((response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.rejection_reason) === "order_amount_too_high") {
          navigateTo("/finance-apply-tabby/payment-cancel-exceeds-limit?post_id=".concat(post_id));
        } else if ((response === null || response === void 0 ? void 0 : (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.rejection_reason) === "order_amount_too_low" || (response === null || response === void 0 ? void 0 : (_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.rejection_reason) === "not_available") {
          navigateTo("/finance-apply-tabby/not-illegible?post_id=".concat(post_id));
        } else if (response !== null && response !== void 0 && (_response$data7 = response.data) !== null && _response$data7 !== void 0 && _response$data7.rejection_reason) {
          navigateTo("/finance-apply-tabby/payment-failed?post_id=".concat(post_id));
        } else {
          toast.error(tShort("tamara/payment_session_error"));
        }
        if (setIsOtpLoading) setIsOtpLoading(false);
      }
    })["catch"](function (error) {
      setIsOtpStep(false);
      console.error("Error creating Tabby checkout after OTP:", error);
      toast.error(tShort("tamara/connection_error"));
      if (setIsOtpLoading) setIsOtpLoading(false);
    });
  };

  // Extract car header data for the desktop specs bar (Figma 253:84189).
  var carHeader = checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : (_checkoutOrderV2$sect6 = checkoutOrderV2.sections) === null || _checkoutOrderV2$sect6 === void 0 ? void 0 : (_checkoutOrderV2$sect7 = _checkoutOrderV2$sect6.find(function (s) {
    return s.type === "car_header";
  })) === null || _checkoutOrderV2$sect7 === void 0 ? void 0 : (_checkoutOrderV2$sect8 = _checkoutOrderV2$sect7.items) === null || _checkoutOrderV2$sect8 === void 0 ? void 0 : _checkoutOrderV2$sect8[0];
  var carSpecs = ((_carHeader$specs = carHeader === null || carHeader === void 0 ? void 0 : carHeader.specs) !== null && _carHeader$specs !== void 0 ? _carHeader$specs : []).map(function (s) {
    return {
      label: s.label,
      value: s.value
    };
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "relative !pt-2 !mt-0 md:!pt-0 md:!mt-8 after:content-[''] after:fixed after:bottom-0 after:left-0 after:w-full after:h-full after:z-[-1] after:bg-[#f4f7fb] sm:after:bg-[#fbfcff] mx-auto w-full max-w-[1152px] sm:!w-[90%] lg:!w-[80%]"
  }, isDesktop && carHeader && /*#__PURE__*/React.createElement(CarSpecsHeader, {
    image: carHeader.car_image,
    imageAlt: carHeader.car_title,
    subtitle: carHeader.car_origin,
    title: (_carHeader$car_title = carHeader.car_title) !== null && _carHeader$car_title !== void 0 ? _carHeader$car_title : "",
    specs: carSpecs,
    className: "mb-7"
  }), /*#__PURE__*/React.createElement("div", {
    className: twMerge("flex flex-col-reverse sm:flex-row items-start justify-between mt-0", !isMobile && "gap-[22px] md:!mt-4", !isMobile && "sm:gap-6 sm:rounded-2xl sm:border sm:border-solid sm:border-[#e1e8f2] sm:bg-white sm:py-8 sm:shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.08),0px_1px_3px_0px_rgba(0,0,0,0.08)]")
  }, /*#__PURE__*/React.createElement("div", {
    className: twMerge("relative w-full sm:flex-1 sm:min-w-0", isMobile && "pb-[160px]", !isMobile && "px-6")
  }, isMobile && /*#__PURE__*/React.createElement("div", {
    className: "px-4 pt-3 pb-4"
  }, /*#__PURE__*/React.createElement(WarrantyBanner, {
    checkoutOrderV2: checkoutOrderV2,
    orderType: "tabby",
    referralLocation: "checkout",
    onWarrantyChange: function onWarrantyChange(id) {
      return void (remote_actions === null || remote_actions === void 0 ? void 0 : remote_actions.fetch__getOrderDetailsByParamsV2({
        warranty_id: id,
        city_id: String((userInfo === null || userInfo === void 0 ? void 0 : userInfo.city_id) || "")
      }));
    }
  })), /*#__PURE__*/React.createElement(TabbyInfoComponent, {
    autosend: autosend,
    setIsOtpStep: setIsOtpStep,
    onFormUpdated: onFormUpdated,
    onFormCompleted: onFormCompleted
  })), isDesktop && /*#__PURE__*/React.createElement("div", {
    id: "checkout-payment-container",
    className: "w-full sm:flex-none sm:w-[43%] sm:px-6 sm:pb-8"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "mb-4 py-2 text-xl font-bold text-[#00143c]"
  }, tShort("flexible_payment/details_title", {
    ns: "web_checkout_finance"
  })), /*#__PURE__*/React.createElement(SplitPaymentDetails, {
    loading: fetch_loading || !checkoutOrderV2,
    checkoutOrderV2: checkoutOrderV2,
    onWarrantySelected: function onWarrantySelected(id) {
      return void (remote_actions === null || remote_actions === void 0 ? void 0 : remote_actions.fetch__getOrderDetailsByParamsV2({
        warranty_id: id,
        city_id: String((userInfo === null || userInfo === void 0 ? void 0 : userInfo.city_id) || "")
      }));
    },
    warrantyOrderType: "tabby"
  })))), /*#__PURE__*/React.createElement(LegacyBottomSheet, {
    open: isOtpStep,
    onOpen: function onOpen() {},
    onClose: function onClose() {
      return setIsOtpStep(false);
    },
    screens: [{
      key: "tabby-otp",
      component: /*#__PURE__*/React.createElement(TabbyOTPStep, {
        userInfo: userInfo,
        onVerified: handleOtpVerified,
        post_id: Number((checkoutOrderV2 === null || checkoutOrderV2 === void 0 ? void 0 : checkoutOrderV2.post_id) || 0),
        financestep: 1
      })
    }],
    hideTitleBar: true,
    haveClose: true,
    customClassName: "modalHideHeader",
    maxWidthDesktop: "900px",
    maxHeight: "76vh"
  }));
};
export default TabbyFormContent;